import axios from "axios";
import React from 'react';
import { injectIntl, intlShape } from "react-intl";
import * as constants from "../../../util/constants";
import EventList from "../../common/EventList";
import Propertii from "../../common/Propertii";

class Events extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            landlord: null,
            validationList: [],
        };
    }

    /**
     * Retrieve the landlord based on the ID provided in the route.
     */
    componentDidMount() {

        axios.get(`${constants.REACT_APP_HOST_API_URL}/landlord/${this.props.match.params.landlordId}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                landlord: response.data
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Render the component.
     *
     * @returns {*} - The landlord event list component.
     */
    render() {

        return(
            <React.Fragment>

                {this.state.landlord &&
                <EventList userId={this.state.landlord.id} companyId={this.state.landlord.companyId} />
                }

            </React.Fragment>
        )
    };
}

Events.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Events);